module.exports = __webpack_public_path__ + "assets/img/4_153.57230b39.jpg";